import cn from "classnames";
import { useMediaQuery } from "@hooks/useMediaQuery";
import i from "@styles/icons.module.scss";
import s from "./Tooltip.module.scss";

const Tooltip = ({
  title,
  style,
  className,
  children,
  contentClass,
  position = "top",
  centred = true,
}) => {
  const { isMobile } = useMediaQuery();
  const classes = cn(
    s.tooltip,
    s[position],
    isMobile && centred && s.center,
    className
  );
  return (
    <div className={classes} style={style}>
      <div className={s.target}>
        {title || <icon className={i.infoCircle} />}
      </div>
      <div className={cn(s.content, contentClass)}>
        <div className={s.wrap}>
          <div className={s.triangle} />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
